export default "__VITE_ASSET__123a77a6__"